import { createSelector } from 'reselect';
import MetadataConstants from 'invision-core/src/components/metadata/metadata.constants';
import MetadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import { addressStateRegionProvinceValueOptionsForCountry } from '../helpers/customer.selectors.helpers';
import propEq from 'ramda/src/propEq';
import find from 'ramda/src/find';
import Immutable from 'seamless-immutable';
import pathOr from 'ramda/src/pathOr';
import { PortInRequestAdditionalPropertiesSelector } from 'invision-core/src/components/metadata/codes/codes.additional.properties.selectors';
import { additionalPropertiesMergeValuesIntoTemplate } from 'invision-core/src/components/metadata/codes/codes.helpers';
var StoreSelector = function StoreSelector(state) {
  return state.customercare.recoverableUiState.mobileNumberPortability;
};
export var MobileNumberPortabilityAddressModelSelector = createSelector([StoreSelector], function (store) {
  return store.addressModel;
});
export var MobileNumberPortabilityModelSelector = createSelector([StoreSelector], function (store) {
  return store.portabilityModel;
});
export var MobileNumberPortabilityShowPortabilitySelector = createSelector([StoreSelector], function (store) {
  return !!store.showPortability;
});
export var IsResumingCartWithMnpData = createSelector([StoreSelector], function (store) {
  return !!store.isResumingCartWithMnpData;
});
export var MobileNumberPortabilityAttributesSelector = createSelector([StoreSelector], function (store) {
  return Immutable(store.savedPortabilityAttributes);
});
var EMPTY_REGEX = {
  regEx: '',
  mask: ''
};
export var PostalCodeRegexSelector = createSelector([MobileNumberPortabilityAddressModelSelector, MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressCountry)], function (addressModel, codes) {
  var country = addressModel.Country;
  if (country && codes.length > 0) {
    var countryObj = find(propEq(country, 'Value'))(codes);
    if (countryObj) {
      var regex = find(propEq('zip_code_reg_expression', 'Key'))(countryObj.AdditionalProperties).Value;
      var mask = find(propEq('zip_code_mask', 'Key'))(countryObj.AdditionalProperties).Value;
      return {
        regEx: new RegExp(regex),
        mask: mask
      };
    }
  }
  return EMPTY_REGEX;
});
export var StateOptionsSelector = createSelector([MobileNumberPortabilityAddressModelSelector, MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressCountry), MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressStateProvinceRegion)], function (addressData, countries, states) {
  return addressStateRegionProvinceValueOptionsForCountry(addressData.Country, countries, states);
});
export var MnpAdditionalPropertiesSelector = createSelector([MobileNumberPortabilityModelSelector, PortInRequestAdditionalPropertiesSelector], function (portabilityModel, mnpAdditionalPropertyFields) {
  var editedAdditionalProps = pathOr([], ['mnpAdditionalProps'], portabilityModel);
  return Immutable(additionalPropertiesMergeValuesIntoTemplate(mnpAdditionalPropertyFields, editedAdditionalProps));
});